import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';
import { NavigationItemEntrySchema } from './navigation-item.validator';

export const NavigationGroupEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    label: z.string(),
    items: z.array(NavigationItemEntrySchema),
    accessType: z.array(z.enum(['Customer', 'Guest', 'Internal', 'Pending', 'Public'])).optional()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
